import React from 'react';
import Tab, { TabGroup as TabGroupLib } from '@amzn/meridian/tab';
import { useAppSelector } from 'src/store/store';
import { useDispatch } from 'react-redux';
import { setSelectedTab } from 'src/store/adminConfigPageSlice/adminConfigPageSlice';
import { useNavigate } from 'react-router-dom';

const TAB_TO_PATH: Record<string, string> = {
  'site-config': '/siteConfiguration',
  'task-config': '/taskConfiguration',
  'form-config': '/restrictionFormConfiguration',
  'modification-config': '/jobModificationConfiguration',
};

const TabGroup = () => {
  const { selectedTab } = useAppSelector((state) => state.adminConfigPage);
  const { selectedRegion } = useAppSelector((state) => state.regionTasksConfigPage);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  return (
    <TabGroupLib
      value={selectedTab}
      onChange={(newTab) => {
        dispatch(setSelectedTab(newTab));
        navigate(TAB_TO_PATH[newTab]);
      }}
    >
      <Tab value="site-config">Site Configuration</Tab>
      <Tab value="task-config">Task Configuration</Tab>
      <Tab value="form-config">Work/Requirement Form Configuration</Tab>
      <Tab value="modification-config">Task Modification Configuration</Tab>
      {selectedRegion.id > 0 && <Tab value="form-tasks-config">{selectedRegion.name} Edit</Tab>}
    </TabGroupLib>
  );
};

export default TabGroup;
